import { useSyncExternalStore } from "react";
import zh from "./locales/zh-CN.json";

export type Locale = "en" | "zh-CN";
const key = "swarm.workbench.locale";
const changed = "swarm-locale-changed";
let volatile: Locale | undefined;
function locale(): Locale {
  if (volatile) return volatile;
  try { return localStorage.getItem(key) === "zh-CN" ? "zh-CN" : "en"; } catch { return "en"; }
}
function subscribe(notify: () => void) {
  window.addEventListener(changed, notify);
  window.addEventListener("storage", notify);
  return () => { window.removeEventListener(changed, notify); window.removeEventListener("storage", notify); };
}
/** React subscription, not DOM rewriting. Changing language never remounts a
 * composer or translates model content, paths, API fields, or command payloads. */
export function useLocale() {
  return useSyncExternalStore(subscribe, locale, () => "en" as Locale);
}
export function setLocale(value: Locale): boolean {
  let saved = true;
  try { localStorage.setItem(key, value); volatile = undefined; } catch { volatile = value; saved = false; }
  document.documentElement.lang = value;
  window.dispatchEvent(new Event(changed));
  return saved;
}
/** Keys are the English source messages. Only explicitly wrapped UI strings
 * are translated. Unknown provider/server diagnostics stay verbatim. */
export function t(source: string): string {
  if (locale() !== "zh-CN") return source;
  const value = (zh as Record<string, string>)[source.trim()];
  if (value === undefined) return source;
  return (source.match(/^\s*/)?.[0] ?? "") + value + (source.match(/\s*$/)?.[0] ?? "");
}
